
'use strict';
(function(angular) {
  angular
    .module('activationApp')
    .controller("Step4Ctrl", [
      '$scope',
      '$location',
      'dataService',
      '$rootScope',
      '$log',
      'payment',
      'activationService',
      'locationService',
      'eapik',
      'billingService',
      '$timeout',
      'cookieService',
      'vcRecaptchaService',
      'recaptchaKey',
      function(
        $scope,
        $location,
        dataService,
        $rootScope,
        $log,
        payment,
        activationService,
        locationService,
        eapik,
        billingService,
        $timeout,
        cookieService,
        vcRecaptchaService,
        recaptchaKey,
      ) {
        var eziDebitCustomerData = undefined;

        $scope.recaptchaKey = recaptchaKey;
        var captchaToken = undefined;
        $scope.onCaptchaSuccess = function(token) {
          captchaToken = token;
        };

        var captchaWidgetId = undefined;
        $scope.onCaptchaCreate = function(widgetId) {
          captchaWidgetId = widgetId;
        };

        $scope.onCaptchaExpire = function() {
          captchaToken = undefined;
        };

        function getLatestEzidebutActionTimestamp() {
          if ($scope.$parent.latestEzidebutActionTimestamp) {
            return $scope.$parent.latestEzidebutActionTimestamp;
          } else {
            return 0;
          }
        }

        $scope.proceedDisabled = function() {
          if (angular.isUndefined(captchaToken)) {
            return true;
          }
          return false;
        };

        $scope.processPayment = function() {
          if ($scope.proceedDisabled()) {
            return;
          }

          if (angular.isDefined(eziDebitCustomerData)) {
            // EziDebit data already updated, bypass and directly call handler.
            return saveEzidebitCustomerSucceeded(eziDebitCustomerData);
          }

          var timeSinceLastAction = _.now() - getLatestEzidebutActionTimestamp();
          if (timeSinceLastAction > 60000) {
            angular.element("#btnSubmitPayment_").click();
          } else {
            $timeout($scope.processPayment, 60000 - timeSinceLastAction);
            $scope.$parent.processing = true;
          }
        };

        $scope.$parent.step4error = false;
        $scope.$parent.step4readableError = '';

        $scope.reactivation = $rootScope.reactivation;

        $scope.details = $scope.$parent.details;

        if ($rootScope.reactivation) {
          try {
            if (isNaN(parseInt($scope.details.payment.ezidebit_reference, 10))) {
              $scope.details.payment.ezidebit_reference = null;
            }
          } catch (err) {
            $scope.details.payment.ezidebit_reference = null;
          }
          billingService.getAnniversaryDate()
            .then(function(anniversaryDate) {
              $scope.anniversaryDate = anniversaryDate;
            });
        } else {
          $scope.details.payment.ezidebit_reference = null;
        }

        function initEziDebitLibrary() {
          if (typeof eziDebit === 'undefined') {
            $log.debug('EziDebit module not found');
            return;
          }

          var action = 'SaveCustomer',
            eziDebitEndpointUrl = "https://api.ezidebit.com.au/v3-3/public-rest";

          if ($rootScope.reactivation && $scope.details.payment.ezidebit_reference) {
            // Change action when reactivating account to update an existing ezidebit reference.
            action = 'ChangeCustomerPaymentInfo';
          }

          var eziDebitOptions = {
            submitAction: action,
            submitButton: "btnSubmitPayment_",
            submitCallback: saveEzidebitCustomerSucceeded,
            submitError: saveEzidebitCustomerFailed,
            customerLastName: "txtCustomerLastName",
            cardCCV: "txtCCV",
            nameOnCard: "txtNameOnCard",
            cardNumber: "txtCardNumber",
            cardExpiryMonth: "txtExpiryMonth",
            cardExpiryYear: "txtExpiryYear"
          };

          if ($rootScope.reactivation) {
            eziDebitOptions.customerRef = "txtCustomerReference";
          }

          eziDebit.init(
            eapik,
            eziDebitOptions,
            eziDebitEndpointUrl);
        }

        function saveCustomerSucceeded(responseObject) {
          /* -------Delete any existing cookies, to cause a fresh loginto Bridging/Webstore and Retail------- */
          cookieService.deleteAuthenticationCookies();
          $scope.$parent.step4error = false;
          $scope.$parent.processing = false;
          $rootScope.user = responseObject;
          $rootScope.user.success = true;

          $scope.$parent.goNext();
        }

        function saveCustomerFailed(error) {
          $scope.$parent.step4error = error;
          $scope.$parent.processing = false;
          $scope.errorMessage = error;
          $scope.errored = true;

          if (!$rootScope.reactivation) {
            delete $scope.$parent.details.payment.ezidebit_reference;
          }

          if (!$scope.$parent.$$phase) {
            $scope.$digest();
          }
        }

        function saveEzidebitCustomerSucceeded(
          responseObject
        ) {
          /*
           *https://api.demo.ezidebit.com.au/v3-3/public-rest/AddCustomer?PublicKey=5df79db1-db53-47af-ba58-e8f60e47cde6&YourSystemReference=&YourGeneralReference=&LastName=McLaren&FirstName=&AddressLine1=&AddressLine2=&AddressSuburb=&AddressState=&AddressPostCode=&EmailAddress=&MobilePhoneNumber=&ContractStartDate=Tue%20Apr%2005%202022&SmsPaymentReminder=N&SmsFailedNotification=N&SmsExpiredCard=N&Username=&CreditCardNumber=4375880590829283&CreditCardExpiryMonth=1&CreditCardExpiryYear=2023&CreditCardCCV=111&NameOnCreditCard=Test%20Card&PaymentAmount=0&PaymentReference=&AccountName=&AccountBSB=&AccountNumber=&ReferrerURL=http%3A%2F%2Flocal-dev.fetchtv.com.au%2Factivate%2F%23%2Factivate%2Fstep4&UserAgent=Mozilla%2F5.0%20(X11%3B%20Linux%20x86_64%3B%20rv%3A98.0)%20Gecko%2F20100101%20Firefox%2F98.0&Version=2.0.0&callback=json2
           *Sample response:
           *{
           *  "Data": {
           *    "BankReceiptId":null,
           *    "CustomerRef": //1220246
           *  },
           *  "Error":0,
           *  "ErrorMessage": null
           *}
           */
          eziDebitCustomerData = responseObject;

          $scope.$parent.latestEzidebutActionTimestamp = +(new Date());
          $scope.$parent.step4error = false;
          $scope.$parent.processing = true;

          if (responseObject.Data && responseObject.Data.CustomerRef) {
            $scope.$parent.details.payment.ezidebit_reference = responseObject.Data.CustomerRef;
          }

          var activationDetails = $scope.$parent.details;
          var pendingAction = undefined;
          if ($rootScope.reactivation) {
            pendingAction = activationService.unhibernate(
              activationDetails,
              captchaToken
            );
          } else {
            pendingAction = activationService.activate(
              activationDetails,
              captchaToken
            );
          }

          pendingAction
            .then(
              saveCustomerSucceeded,
              saveCustomerFailed
            )['finally'](function() {
              // Reset captcha component
              captchaToken = undefined;
              vcRecaptchaService.reset(captchaWidgetId);
            });

          if (!$scope.$parent.$$phase) {
            $scope.$digest();
          }
        }

        function saveEzidebitCustomerFailed(responseObject) {
          // Clear any saved response data
          eziDebitCustomerData = undefined;

          $scope.$parent.step4error = responseObject;
          $scope.$parent.processing = false;
          //TODO: report error to user for action
          $scope.$parent.step4readableError = JSON.stringify(responseObject);

          if (!$scope.$$phase) {
            $scope.$apply();
          }

          $('#btnSubmitPayment').attr('disabled', false);

          if (!$scope.$parent.$$phase) {
            $scope.$digest();
          }
        }

        function init() {
          if (!angular.isDefined($rootScope.user)) {
            $location.path('/welcome');
          }
          initEziDebitLibrary();
          $scope.root = $rootScope;
        }
        init();
      }
    ]);
})(angular);
